import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ServiceAgreementModificationInformationResponse,
  ServiceAgreementV2,
  ServiceRole,
  ContactNoteResponse,
} from 'pco-product-service-internal-consumer';

interface ServiceAgreementState {
  tableData: Array<ServiceAgreementV2>;
  selectedServiceAgreement: ServiceAgreementV2 | null;
  selectedServiceAgreementAttributes: Record<string, unknown>[] | null;
  selectedServiceAgreementServiceRoles: ServiceRole[];
  isTableDataLoading: boolean;
  modificationData?: ServiceAgreementModificationInformationResponse;
  contactNote?: ContactNoteResponse | null;
  agreementsToClose?: Array<string>;
  inBulkClosing?: boolean;
  contactNoteId?: string;
  openedTaskUid?: string | null;
}

const initialState: ServiceAgreementState = {
  tableData: [],
  selectedServiceAgreement: null,
  selectedServiceAgreementAttributes: null,
  selectedServiceAgreementServiceRoles: [],
  isTableDataLoading: false,
  contactNote: null,
  openedTaskUid: null,
  agreementsToClose: [],
  inBulkClosing: false,
  contactNoteId: '',
};

const serviceAgreementsSlice = createSlice({
  name: 'serviceAgreementsSlice',
  initialState: initialState,
  reducers: {
    setTableData(state, action: PayloadAction<ServiceAgreementV2[]>) {
      state.tableData = action.payload;
    },
    setSelectedServiceAgreement(state, action: PayloadAction<ServiceAgreementV2 | null>) {
      state.selectedServiceAgreement = action.payload;
    },
    setSelectedServiceAgreementAttributes(state, action: PayloadAction<Record<string, unknown>[]>) {
      state.selectedServiceAgreementAttributes = action.payload;
    },
    setSelectedServiceAgreementServiceRoles(state, action: PayloadAction<ServiceRole[]>) {
      if (!state.selectedServiceAgreement) {
        return;
      }
      state.selectedServiceAgreement.serviceRoles = action.payload;
    },
    setModificationData(state, action: PayloadAction<ServiceAgreementModificationInformationResponse>) {
      state.modificationData = action.payload;
    },
    setIsTableDataLoading(state, action: PayloadAction<boolean>) {
      state.isTableDataLoading = action.payload;
    },
    setContactNotes(state, action: PayloadAction<ContactNoteResponse>) {
      state.contactNote = action.payload;
    },
    setAgreementsToClose(state, action: PayloadAction<Array<string>>) {
      state.agreementsToClose = action.payload;
    },
    setInBulkClosing(state, action: PayloadAction<boolean>) {
      state.inBulkClosing = action.payload;
    },
    setContactNoteId(state, action: PayloadAction<string>) {
      state.contactNoteId = action.payload;
    },
    setOpenedTaskUid(state, action: PayloadAction<string | undefined | null>) {
      state.openedTaskUid = action.payload;
    },
  },
});

export const {
  setTableData,
  setSelectedServiceAgreement,
  setSelectedServiceAgreementAttributes,
  setSelectedServiceAgreementServiceRoles,
  setIsTableDataLoading,
  setModificationData,
  setContactNotes,
  setAgreementsToClose,
  setInBulkClosing,
  setContactNoteId,
  setOpenedTaskUid,
} = serviceAgreementsSlice.actions;

export default serviceAgreementsSlice.reducer;
